import request from './api/request'
import utils from '@/utils/index'
import pfile from '@/utils/secretkey/pfile'
import sfile from '@/utils/secretkey/sfile'

var ak = utils.genak()
var ed = utils.re(ak, unescape(pfile)) //秘钥

function decrypt(data) {
  if (data?.ak) {
    let plaintext = utils.rd(data.ak, unescape(sfile))
    let obj = utils.secret(data.ed, plaintext, true)
    return JSON.parse(obj)
  } else {
    return data
  }
}

function inParameter(data) {
  if (data) {
    return { sn: ed, jt: utils.secret(data, ak) }
  } else {
    return data
  }
}

export function loginOutAPI(data) {
  return request({
    url: '/user-service/passport/loginOut',
    method: 'post',
    data,
  }).catch(err => {})
}
export function LoginSSOAPI(data) {
  return request({
    url: `/user-service/sso/login?&token=${data.token}&is_cross=1`,
    method: 'get',
  })
    .then(res => {
      res.data = decrypt(res.data)
      return res
    })
    .catch(err => {})
}
//登录接口
export function loginAPI(data) {
  return request({
    url: '/user-service/passport/login',
    method: 'post',
    data: inParameter(data),
  })
    .then(res => {
      res.data = decrypt(res.data)
      return res
    })
    .catch(err => {
      console.log(err)
    })
}
//多账号验证
export function userLoginVerifyAPI(data) {
  return request({
    url: '/user-service/passport/userLoginVerify',
    method: 'post',
    data: inParameter(data),
  })
    .then(res => {
      res.data = decrypt(res.data)
      return res
    })
    .catch(err => {
      console.log(err)
    })
}
//登录受限
export function limitationDelAPI(data) {
  return request({
    url: '/user-service/passport/limitationDel',
    method: 'post',
    data: inParameter(data),
  })
    .then(res => {
      res.data = decrypt(res.data)
      return res
    })
    .catch(err => {
      console.log(err)
    })
}
// 浏览器登录地点
export function browserLoginAddressAPI(data) {
  return request({
    url: '/user-service/device/pcBrowserLoginAddress',
    method: 'post',
    data,
  })
    .then(res => {
      res.data = decrypt(res.data)
      return res
    })
    .catch(err => {})
}
//网页端删除登录地点
export function pcQuitLoginAddressAPI(data) {
  return request({
    url: '/user-service/device/pcQuitLoginAddress',
    method: 'post',
    data,
  })
    .then(res => {
      res.data = decrypt(res.data)
      return res
    })
    .catch(err => {})
}
//获取国家区号getPhonePcode
export function getPhonePcodeAPI(data) {
  return request({
    url: '/user-service/common/getPhonePcode',
    method: 'post',
    data: inParameter(data),
  })
    .then(res => {
      res.data = decrypt(res.data)
      return res
    })
    .catch(err => {})
}
//发送验证码
export function phoneLoginCodeAPI(data) {
  return request({
    url: '/user-service/passport/phoneLoginCode',
    method: 'post',
    data: inParameter(data),
  })
    .then(res => {
      res.data = decrypt(res.data)
      return res
    })
    .catch(err => {})
}
//验证手机号
export function checkPhone(data) {
  return request({
    url: '/user-service/passport/checkPhoneCode',
    method: 'post',
    data: inParameter(data),
  })
    .then(res => {
      res.data = decrypt(res.data)
      return res
    })
    .catch(err => {})
}
export function registerAPI(data) {
  return request({
    url: '/user-service/passport/register',
    method: 'post',
    data,
  })
    .then(res => {
      res.data = decrypt(res.data)
      return res
    })
    .catch(err => {})
}
export function forgetPasswordAPI(data) {
  return request({
    url: '/user-service/passport/forgetPasswordCheck',
    method: 'post',
    data,
  })
    .then(res => {
      res.data = decrypt(res.data)
      return res
    })
    .catch(err => {})
}
export function resetPasswordAPI(data) {
  return request({
    url: '/user-service/passport/resetPassword',
    method: 'post',
    data,
  })
    .then(res => {
      res.data = decrypt(res.data)
      return res
    })
    .catch(err => {})
}
//QQ和微信注册手机号
export function checkQQ(data) {
  return request({
    url: '/user-service/passport/createAccount',
    method: 'post',
    data: inParameter(data),
  })
    .then(res => {
      res.data = decrypt(res.data)
      return res
    })
    .catch(err => {})
}
//获取注册邮箱后缀
export function getEmailRegisterSuffixAPI(data) {
  return request({
    url: '/user-service/passport/getEmailRegisterSuffix',
    method: 'post',
    data,
  })
    .then(res => {
      res.data = decrypt(res.data)
      return res
    })
    .catch(err => {})
}
//h5获取滑块展示信息
export function getSliderInfoAPI(data) {
  return request({
    url: '/validate-service/slider/info',
    method: 'post',
    data,
  }).catch(err => {})
}
//发送邮箱注册验证码
export function sendEmailRegisterCodeAPI(data) {
  return request({
    url: '/user-service/passport/sendEmailRegisterCode',
    method: 'post',
    data,
  })
    .then(res => {
      res.data = decrypt(res.data)
      return res
    })
    .catch(err => {})
}
//注册邮箱验证码验证
export function checkEmailCodeAPI(data) {
  return request({
    url: '/user-service/passport/checkEmailCode',
    method: 'post',
    data,
  })
    .then(res => {
      res.data = decrypt(res.data)
      return res
    })
    .catch(err => {})
}
//邮箱注册
export function emailRegisterAPI(data) {
  return request({
    url: '/user-service/passport/emailRegister',
    method: 'post',
    data,
  })
    .then(res => {
      res.data = decrypt(res.data)
      return res
    })
    .catch(err => {})
}
export function getSyncLogin(data) {
  // 获取同步登陆数组接口
  return request({
    url: '/user-service/passport/getSyncLogin',
    method: 'post',
    data,
  })
    .then(res => {
      res.data = decrypt(res.data)
      return res
    })
    .catch(err => {})
}

//获取区服信息
export function getZoneIdConfigAPI(data) {
  return request({
    url: '/disk-service/common/getZoneIdConfig',
    method: 'post',
    data,
  })
    .then(res => {
      res.data = decrypt(res.data)
      return res
    })
    .catch(err => {})
}
